module.exports = __webpack_public_path__ + "img/check-icon-orange.db3dd909.svg";